/* ============================================
   BUILD YOUR BOX — Shopify Cart Integration
   ============================================ */

(function() {
  'use strict';

  /* --- State --- */
  let currentStep = 1;
  const totalSteps = 4;
  let selectedJarSize = '';
  let selectedBoxCount = 0;
  let modalShown = false;

  /* --- DOM refs --- */
  const steps = document.querySelectorAll('.byb-step');
  const lines = document.querySelectorAll('.byb-step-line');
  const panels = document.querySelectorAll('[data-panel]');
  const btnNext = document.querySelector('[data-byb-next]');
  const btnBack = document.querySelector('[data-byb-back]');
  var modal = null;

  /* --- Step Navigation --- */
  function goToStep(n) {
    /* A box holds exactly the jars it is sized for. Shrinking the box after picking
       (e.g. 8 quarts -> 4 half gallons) kept every flavor and sent all of them to the
       cart with the smaller box, so the review only opens with an exact count. */
    if (n > 3 && getTotalQty() !== selectedBoxCount) n = 3;
    currentStep = Math.max(1, Math.min(n, totalSteps));
    modalShown = false;

    steps.forEach((s, i) => {
      s.classList.remove('active', 'done');
      if (i + 1 < currentStep) s.classList.add('done');
      if (i + 1 === currentStep) s.classList.add('active');
    });
    lines.forEach((l, i) => {
      l.classList.toggle('done', i < currentStep - 1);
    });

    panels.forEach(p => {
      p.style.display = parseInt(p.dataset.panel) === currentStep ? '' : 'none';
    });

    btnBack.style.visibility = currentStep === 1 ? 'hidden' : 'visible';

    if (currentStep === totalSteps) {
      btnNext.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16"><rect width="18" height="11" x="3" y="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg> Add to Cart';
    } else if (currentStep !== 3) {
      btnNext.innerHTML = 'Next <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16"><path d="m9 18 6-6-6-6"/></svg>';
    }

    if (currentStep === 3) {
      const subtitle = panels[2]?.querySelector('.byb-subtitle');
      if (subtitle) subtitle.textContent = `Choose ${selectedBoxCount} jars — mix and match your favorite flavors!`;
    }

    if (currentStep === 4) buildReview();

    updateProgress();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  /* --- Qty & Progress --- */
  function getTotalQty() {
    let total = 0;
    document.querySelectorAll('[data-panel="3"] .byb-product-qty .qty-val').forEach(s => {
      total += parseInt(s.textContent) || 0;
    });
    return total;
  }

  function updateProgress() {
    const count = getTotalQty();
    const el = document.querySelector('[data-jar-count]');
    const maxEl = document.querySelector('[data-jar-max]');
    const fill = document.querySelector('[data-progress-fill]');
    if (el) el.textContent = count;
    if (maxEl) maxEl.textContent = selectedBoxCount || 0;
    if (fill) fill.style.width = selectedBoxCount ? Math.min(100, (count / selectedBoxCount) * 100) + '%' : '0%';
    updateNextBtnState();
  }

  /* Update Next button label/disabled state based on current step + qty */
  function updateNextBtnState() {
    if (!btnNext) return;
    if (currentStep === 3) {
      const count = getTotalQty();
      const remaining = selectedBoxCount - count;
      if (remaining > 0) {
        btnNext.disabled = true;
        btnNext.classList.add('byb-btn-disabled');
        btnNext.innerHTML = 'Add ' + remaining + ' more jar' + (remaining === 1 ? '' : 's');
      } else if (remaining < 0) {
        btnNext.disabled = true;
        btnNext.classList.add('byb-btn-disabled');
        btnNext.innerHTML = 'Remove ' + (-remaining) + ' jar' + (remaining === -1 ? '' : 's');
      } else {
        btnNext.disabled = false;
        btnNext.classList.remove('byb-btn-disabled');
        btnNext.innerHTML = 'Continue to Review <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16"><path d="m9 18 6-6-6-6"/></svg>';
      }
    } else if (currentStep === totalSteps) {
      btnNext.disabled = false;
      btnNext.classList.remove('byb-btn-disabled');
    } else {
      btnNext.disabled = false;
      btnNext.classList.remove('byb-btn-disabled');
    }
  }

  /* --- Modal --- */
  function getModal() {
    if (!modal) modal = document.querySelector('[data-modal]');
    return modal;
  }

  function showModal() {
    var m = getModal();
    if (m && !modalShown) {
      m.classList.add('active');
      modalShown = true;
      var countEl = m.querySelector('[data-modal-count]');
      if (countEl) countEl.textContent = selectedBoxCount;
    }
  }

  function hideModal() {
    var m = getModal();
    if (m) m.classList.remove('active');
  }

  /* Bind modal buttons with delegation */
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-modal-review]')) { hideModal(); goToStep(4); }
    if (e.target.closest('[data-modal-edit]')) { hideModal(); }
    if (e.target.closest('[data-modal-resize]')) { hideModal(); goToStep(2); }
  });

  /* --- Step 1: Jar Size — auto-advance + show correct grid --- */
  document.querySelectorAll('.byb-size-card').forEach(card => {
    card.addEventListener('click', () => {
      document.querySelectorAll('.byb-size-card').forEach(c => c.classList.remove('selected'));
      card.classList.add('selected');
      selectedJarSize = card.dataset.size;

      /* Show correct box grid for selected jar type */
      var quartGrid = document.querySelector('[data-boxes-quart]');
      var halfGrid = document.querySelector('[data-boxes-halfgallon]');
      if (quartGrid) quartGrid.style.display = selectedJarSize === 'quart' ? '' : 'none';
      if (halfGrid) halfGrid.style.display = selectedJarSize === 'halfgallon' ? '' : 'none';

      setTimeout(() => goToStep(2), 350);
    });
  });

  /* --- Step 2: Box Count — auto-advance --- */
  document.querySelectorAll('.byb-count-card').forEach(card => {
    card.addEventListener('click', () => {
      /* Only deselect cards in the same grid */
      var grid = card.closest('.byb-count-grid');
      if (grid) grid.querySelectorAll('.byb-count-card').forEach(c => c.classList.remove('selected'));
      card.classList.add('selected');
      selectedBoxCount = parseInt(card.dataset.count) || 8;
      updateProgress();
      setTimeout(() => goToStep(3), 350);
    });
  });

  /* --- Step 3: Filters --- */
  document.querySelectorAll('.byb-filter-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.byb-filter-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      const filter = (btn.dataset.filter || 'all').toLowerCase();
      document.querySelectorAll('[data-panel="3"] .byb-product').forEach(p => {
        const tags = (p.dataset.tags || '').split(',').map(t => t.trim().toLowerCase());
        const show = filter === 'all' || tags.includes(filter);
        p.style.display = show ? '' : 'none';
      });
    });
  });

  /* --- Step 3: Qty buttons --- */
  document.querySelectorAll('.byb-product-qty button').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const span = btn.parentElement.querySelector('.qty-val');
      const product = btn.closest('.byb-product');
      let val = parseInt(span.textContent);
      const total = getTotalQty();
      const isPlus = btn.textContent.trim() === '+';

      if (isPlus) {
        if (total >= selectedBoxCount) return;
        span.textContent = val + 1;
        product.classList.add('added');
        if (total + 1 >= selectedBoxCount) showModal();
      } else if (val > 0) {
        span.textContent = val - 1;
        if (val - 1 === 0) product.classList.remove('added');
      }

      updateProgress();
    });
  });

  /* --- Step 4: Build Review --- */
  function buildReview() {
    const reviewList = document.querySelector('[data-review-items]');
    if (!reviewList) return;

    reviewList.innerHTML = '';
    const selectedProducts = [];

    document.querySelectorAll('[data-panel="3"] .byb-product').forEach(product => {
      const qty = parseInt(product.querySelector('.qty-val')?.textContent) || 0;
      if (qty === 0) return;

      const name = product.querySelector('.byb-product-name')?.textContent || '';
      const imgSrc = product.querySelector('.byb-product-img img')?.src || '';
      const productId = product.dataset.productId || '';
      const variantId = product.dataset.variantId || '';

      selectedProducts.push({ name, qty, productId, variantId, imgSrc });

      reviewList.innerHTML += `
        <div class="byb-review-item">
          <div class="byb-review-item-img"><img src="${imgSrc}" alt="${name}"></div>
          <div class="byb-review-item-info">
            <div class="byb-review-item-name">${name}</div>
            <div class="byb-review-item-variant">${selectedJarSize === 'halfgallon' ? 'Half Gallon' : 'Quart'}</div>
          </div>
          <div class="byb-review-item-qty">x${qty}</div>
        </div>
      `;
    });

    // Total = fixed box price from step 2 (the selected .byb-count-card)
    const visibleGrid = selectedJarSize === 'halfgallon'
      ? document.querySelector('[data-boxes-halfgallon]')
      : document.querySelector('[data-boxes-quart]');
    const selectedCard = visibleGrid?.querySelector('.byb-count-card.selected');
    const priceText = selectedCard?.querySelector('.count-save')?.textContent || '';
    const totalPrice = parseFloat(priceText.replace(/[^0-9.]/g, '')) || 0;

    // Update summary
    const jarEl = document.querySelector('[data-review-jar]');
    const boxEl = document.querySelector('[data-review-box]');
    const shipEl = document.querySelector('[data-review-shipping]');
    const totalEl = document.querySelector('[data-review-total]');
    const savingsEl = document.querySelector('[data-review-savings]');

    if (jarEl) jarEl.textContent = selectedJarSize === 'halfgallon' ? 'Half Gallon' : 'Quart';
    if (boxEl) boxEl.textContent = `${selectedBoxCount} Jars`;

    if (shipEl) {
      shipEl.textContent = 'Calculated at checkout';
      shipEl.style.color = '';
    }
    if (totalEl) totalEl.textContent = '$' + totalPrice.toFixed(2);

    /* Free-shipping savings message removed */
    if (savingsEl) { savingsEl.style.display = 'none'; }

    // Store for checkout
    window.__bybProducts = selectedProducts;
  }

  /* --- Next / Back --- */
  btnNext.addEventListener('click', () => {
    /* Guard: on step 3, block Next until the box holds exactly its jars */
    if (currentStep === 3 && getTotalQty() !== selectedBoxCount) return;

    if (currentStep === totalSteps) {
      addToCartAndCheckout();
    } else {
      goToStep(currentStep + 1);
    }
  });
  btnBack.addEventListener('click', () => goToStep(currentStep - 1));

  /* --- Add to Cart --- */
  async function addToCartAndCheckout() {
    var products = window.__bybProducts || [];
    if (products.length === 0) {
      alert('Please select at least one product.');
      return;
    }
    var jars = products.reduce(function(sum, p) { return sum + p.qty; }, 0);
    if (jars !== selectedBoxCount) {
      goToStep(3);
      return;
    }

    btnNext.disabled = true;
    btnNext.innerHTML = '<svg style="animation:spin 1s linear infinite" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg> Processing...';

    var jarLabel = selectedJarSize === 'halfgallon' ? 'Half Gallon' : 'Quart';

    /* Build properties with all flavors */
    var properties = {
      'Box Type': jarLabel + ' - ' + selectedBoxCount + ' Pack',
      'Jar Size': jarLabel,
      'Box Size': selectedBoxCount + ' Jars'
    };
    var idx = 1;
    products.forEach(function(p) {
      properties['Flavor ' + idx] = p.qty + 'x ' + p.name;
      idx++;
    });

    /* Cart note for admin */
    var noteLines = ['Build Your Box - ' + jarLabel + ' (' + selectedBoxCount + ' Pack)', '---'];
    products.forEach(function(p) { noteLines.push(p.qty + 'x ' + p.name); });
    var cartNote = noteLines.join('\n');

    try {
      /* Fetch Build-your-Box product directly from Shopify */
      var prodRes = await fetch('/products/build-your-box.js');
      var prodData = await prodRes.json();
      var boxVariantId = 0;

      if (prodData && prodData.variants) {
        /*
         * Match by SKU pattern:
         * Quart: BYB_4, BYB_6, BYB_8, BYB_12 (with underscore)
         * Half Gallon: BYB2, BYB4, BYB6 (no underscore)
         */
        var targetSku = '';
        if (selectedJarSize === 'quart') {
          targetSku = 'BYB_' + selectedBoxCount;
        } else {
          targetSku = 'BYB' + selectedBoxCount;
        }

        /* Search by SKU first (most reliable) */
        prodData.variants.forEach(function(v) {
          if (v.sku && v.sku.toUpperCase() === targetSku.toUpperCase()) {
            boxVariantId = v.id;
          }
        });

        /* Fallback: search by option text */
        if (!boxVariantId) {
          var searchJar = selectedJarSize === 'halfgallon' ? 'half' : 'quart';
          var searchCount = String(selectedBoxCount);
          prodData.variants.forEach(function(v) {
            var allText = ((v.option1 || '') + ' ' + (v.option2 || '') + ' ' + (v.title || '') + ' ' + (v.sku || '')).toLowerCase();
            if (allText.indexOf(searchJar) !== -1 && allText.indexOf(searchCount) !== -1) {
              boxVariantId = v.id;
            }
          });
        }

        console.log('Build Your Box — SKU:', targetSku, '→ Variant ID:', boxVariantId);
      }

      if (boxVariantId) {
        /* Add Build-your-Box product with flavor properties */
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: boxVariantId,
              quantity: 1,
              properties: properties
            }]
          })
        });

        /* Set cart note — rebuild from all BYB items in cart */
        var cartRes = await fetch('/cart.js');
        var cartData = await cartRes.json();
        var allNotes = [];
        cartData.items.forEach(function(item) {
          if (item.properties && item.properties['Box Type']) {
            var header = 'Build Your Box - ' + item.properties['Box Type'];
            if (item.quantity > 1) header += ' (x' + item.quantity + ')';
            var lines = [header, '---'];
            Object.keys(item.properties).forEach(function(k) {
              if (k.indexOf('Flavor') === 0 && item.properties[k]) {
                lines.push(item.properties[k]);
              }
            });
            allNotes.push(lines.join('\n'));
          }
        });
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: allNotes.join('\n\n') })
        });

        /* Go home and open cart drawer */
        window.location.href = '/#cart';
      } else {
        alert('Could not find the right box variant. Please try again or contact support.');
        resetCheckoutBtn();
      }

    } catch (err) {
      console.error('Checkout error:', err);
      alert('Something went wrong. Please try again.');
      resetCheckoutBtn();
    }
  }

  function resetCheckoutBtn() {
    btnNext.disabled = false;
    btnNext.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16"><rect width="18" height="11" x="3" y="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg> Add to Cart';
  }

  // Add spin animation
  document.head.insertAdjacentHTML('beforeend', '<style>@keyframes spin{to{transform:rotate(360deg)}}</style>');

  /* --- Init --- */
  // Set defaults from pre-selected cards
  const defaultJar = document.querySelector('.byb-size-card.selected');
  if (defaultJar) selectedJarSize = defaultJar.dataset.size || 'quart';

  const defaultBox = document.querySelector('.byb-count-card.selected');
  if (defaultBox) selectedBoxCount = parseInt(defaultBox.dataset.count) || 8;

  goToStep(1);

})();
